<template>
    <div>
        <app-model :class="{ 'show': show }" size="modal-xl">
            <template v-slot:header class="modal-header d-flex align-items-center">
                <h4 class="card-title mb-0">Agregar participantes</h4>
                <button type="button" @click="$emit('onClose')" class="btn-close"></button>
            </template>
            <template v-slot:body class="modal-body">
                <div class="row mb-2">
                  <div class="col-lg-6 py-1">
                    <div class="form-group">
                      <input type="text" class="form-control form-control-sm" placeholder="Nombre completo" v-model="append.name">
                    </div>
                  </div>
                  <div class="col-lg-6 py-1">
                    <div class="form-group">
                      <input type="text" class="form-control form-control-sm" placeholder="DPI / Pasaporte / (Opcional)" v-model="append.cui">
                    </div>
                  </div>
                  <div class="col-lg-6 py-1">
                    <div class="form-group">
                      <input type="number" class="form-control form-control-sm" placeholder="Edad" v-model="append.age">
                    </div>
                  </div>
                  <div class="col-lg-6 py-1">
                    <div class="form-group">
                      <v-select
                          auto-select-first
                          :items="genders"
                          v-model="append.gender"
                          placeholder="Género"
                          class="form-control form-control-sm"
                          dense
                          hide-details
                          outlined>
                        </v-select>
                    </div>
                  </div>
                  <div class="col-lg-6 py-1">
                    <div class="form-group">
                      <v-autocomplete
                          auto-select-first
                          item-text="nicename"
                          item-value="nicename"
                          :items="countries"
                          v-model="append.country"
                          placeholder="País de Origen"
                          class="form-control form-control-sm"
                          dense
                          hide-details
                          outlined>
                        </v-autocomplete>
                    </div>
                  </div>
                  <div class="col-lg-2 py-1">
                    <button class="btn btn-success btn-sm" @click="$emit('onAppend', append)">
                      <span>
                          <i class="ti ti-save me-1 fs-4"></i> Agregar participante
                      </span>
                    </button>
                  </div>
                </div>
                <hr class="my-4">
                <div>
                  <div class="d-flex justify-content-between align-items-center mb-9">
                    <form class="position-relative">
                        <input type="text" v-model="search" class="form-control form-control-sm search-chat py-2 ps-5" id="text-srh" placeholder="Buscador usuario">
                        <i class="ti ti-search position-absolute top-50 start-0 translate-middle-y fs-6 text-dark ms-3"></i>
                    </form>
                  </div>
                  <div class="table-responsive border rounded">
                    <v-data-table
                      dense
                      :search="search"
                      :headers="headers"
                      :items="data"
                      item-key="name">
                      <template v-slot:[`item.delete`]="{ index, item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <a href="javascript:void(0)" @click="$emit('onDelete', index)" class="link text-danger ms-2" v-bind="attrs" v-on="on">
                              <i class="ti ti-trash fs-4 remove-note"></i>
                            </a>
                          </template>
                          <small>Eliminar</small>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </div>
                </div>
                <div class="text-center" v-if="data.length === 0">
                  <span class="font-weight-light text-muted">Sin participantes</span>
                </div>
            </template>
            <template v-slot:footer class="modal-footer">
                <button type="button" @click="$emit('onClose')"
                    class="btn btn-dark rounded-pill px-4 ms-2 text-white">Cerrar</button>
            </template>
        </app-model>
    </div>
</template>
<script>
export default {
  props: {
    onAppend: {
      type: Function,
      default: () => { console.log('aca') }
    },
    onDelete: {
      type: Function,
      default: () => { console.log('aca') }
    },
    data: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    },
    countries: {
      type: Array,
      default: () => []
    },
    append: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Nombre', value: 'name', sortable: false },
        { text: 'DPI', value: 'cui', sortable: false },
        { text: 'Eliminar', value: 'delete', sortable: false }
      ],
      genders: [
        { value: 'M', text: 'Masculino' },
        { value: 'F', text: 'Femenino' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/steps/TableParticipants.vue